import { API, Auth } from "aws-amplify";
import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { toast } from "react-toastify";
import { ICourtType, ISummary } from "../../types/api";
import { getSlotByMemberQueryFn, getSlotsQueryFn } from "./summaryQueries";

export const getSlotByMember = async (
  datetime_start: string,
  court_id: string,
  court_type: ICourtType,
  member_id?: string,
  drop_in?: boolean
) => {
  const { query, inputs, variables } = getSlotByMemberQueryFn(
    datetime_start,
    court_id,
    court_type,
    member_id,
    drop_in
  );
  const myQuery = `query MyQuery(${inputs}) {
        ${query}
    }`;

  try {
    await Auth.currentSession();
    const getUserResponse = (await API.graphql({
      query: myQuery,
      variables: variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;
    const response = getUserResponse.data.getSlotByMember;

    if ("message" in response) {
      console.error(response.message);
      toast.error(response.message);
    }
    return response;
  } catch (error: any) {
    error.errors ? toast.error(error.errors[0].message) : toast.error(error);
    throw error;
  }
};

/**
 * Every court's slots for one date and court type.
 *
 * Used where the caller needs to apply its own rule to the day rather than ask
 * the backend a question shaped like a time range — the opening-hours conflict
 * check, for instance, has to find slots that straddle the new hours, which no
 * range query can express.
 */
export const getSlotsAdmin = async (
  date: string,
  court_type: ICourtType
): Promise<ISummary[]> => {
  const { query, inputs, variables } = getSlotsQueryFn(date, court_type);
  const myQuery = `query getSlotsAdmin(${inputs}) {
        ${query}
    }`;

  try {
    const response = (await API.graphql({
      query: myQuery,
      variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const summaries = response.data.getSlotsAdmin;
    if (!Array.isArray(summaries)) {
      throw new Error("Kunde inte hämta tider");
    }
    // The resolver returns an Error member per court on failure; drop those
    // rather than letting them masquerade as courts with no slots.
    return summaries.filter(
      (summary: any) => summary && !("message" in summary)
    ) as ISummary[];
  } catch (error: any) {
    const message = error?.errors?.[0]?.message;
    message ? toast.error(message) : toast.error(error);
    throw error;
  }
};
